<div class="custom-alert-container">
  <div class="custom-alert">
    <img [src]="isSMS ? 'assets/img/alerta.png' : 'assets/img/email.png'" alt="Whoops!" class="alert-icon">
    <h2>Oops!</h2>
    <div class="recognized-fields">
      <span class="info">Podrías perderte actualizaciones importantes sobre tu participación en el concurso.</span>
      <p>{{message}}</p>
    
    </div>
    <ion-button (click)="dismiss(true)" fill="outline">Cancelar</ion-button>
    <ion-button  color="primary" (click)="dismiss(false)">Si, acepto</ion-button>
  </div>
</div>
